/**
 * Tailwind classes for rendering `lesson.description` from admin textareas.
 * HTML collapses newlines by default; these preserve line breaks like the form.
 */
export const lessonDescriptionTextClassName = 'whitespace-pre-wrap break-words';

/** Academy / list cards: show "Read more" when description is longer than this (full text on lessons listing). */
export const LESSON_CARD_DESCRIPTION_READ_MORE_THRESHOLD = 200;
